export const ENV = "production";

let API_BASE_URL = "http://localhost:5000/";

if (ENV == "staging") {
  API_BASE_URL =
    "https://gqlip0wnzg.execute-api.us-west-2.amazonaws.com/staging/";
}
if (ENV == "production") {
  API_BASE_URL =
    "https://gqlip0wnzg.execute-api.us-west-2.amazonaws.com/production/";
}

export let PORTAL_BASE_URL = ''
export let WEBSITE_BASE_URL = 'http://localhost:3000'

if (ENV == "staging") {
  PORTAL_BASE_URL = "https://staging.all3d.ai";
  WEBSITE_BASE_URL = 'https://website.all3d.ai'
}
if (ENV == "production") {
  PORTAL_BASE_URL = "https://app.all3d.ai";
  WEBSITE_BASE_URL = 'https://all3d.ai'
}
if (ENV == "local") {
  PORTAL_BASE_URL = "http://localhost:3000";
}

export const AI_EDITOR_STORYLANE_ID = 'svo7zi0jzurc'
export const AI_CREATOR_STORYLANE_ID = '7ax6pjozhc79'

export const BUCKET_NAME = (ENV == 'staging') ? 'all3d-dev' : 'all3d';
//Cloudfront distribution id
export const CLOUDFRONT_ID = (ENV == 'staging') ? 'EWXIJSKOEGJHL':'E1PCYBAKSUG4Z2';
export const FREE_TRIAL_LINK = (ENV == 'staging') ? 'https://staging.all3d.ai/register' : 'https://app.all3d.ai/register';
export const CALENDLY_LINK = 'https://calendar.app.google/ukTZ3hQaW8ei7mho7'
export const BASE_URL =  (ENV == 'staging') ? 'https://all3d-dev.s3.amazonaws.com/test_files/' : 'https://d48f7equ64qjl.cloudfront.net/test_files/';
export const COMPANY_LOGO = (ENV == 'staging') ? 'https://all3d-dev.s3.amazonaws.com/static_files/company/' : 'https://d48f7equ64qjl.cloudfront.net/static_files/company/';
export const ROOM_PANORAMA_ASSET =  (ENV == 'staging') ? "https://all3d-dev.s3.amazonaws.com/room_assets/panorama/" : "https://d48f7equ64qjl.cloudfront.net/room_assets/panorama/";
export const MATERIAL_FILE_URL = (ENV == 'staging') ?  'https://all3d-dev.s3.amazonaws.com/materials/' : 'https://d48f7equ64qjl.cloudfront.net/materials/';
export const SCANS_BASE_URL = "https://all3d-reconstruction.s3.amazonaws.com/temp_results/";
export const SCENE_BASE_URL =  (ENV == 'staging') ? 'https://all3d-dev.s3.amazonaws.com/scene_renders/' : 'https://d48f7equ64qjl.cloudfront.net/scene_renders/';
export const COMPANY_MODEL = (ENV == 'staging') ? 'https://all3d-dev.s3.amazonaws.com/static_files/featured_models/' : 'https://d48f7equ64qjl.cloudfront.net/static_files/featured_models/';
//get categories
export const ADMIN_CATEGORY_BATCH = 'https://xnhluveva9.execute-api.us-west-2.amazonaws.com/staging/all3d-category-get-batch';
export const ADMIN_CATEGORY_GET_BATCH = API_BASE_URL + 'admin-category-get-batch';
export const GET_CATEGORY_AND_PRICE = 'https://0za35gi4ef.execute-api.us-west-2.amazonaws.com/' + ENV;

//get materials
export const ADMIN_MATERIAL_BATCH = 'https://cvs5huxxi0.execute-api.us-west-2.amazonaws.com/staging/all3d-material-get-batch'

export const COMPANY_GET_BATCH = 'https://2pveenfj3h.execute-api.us-west-2.amazonaws.com/' + ENV;
export const GET_STORE_ITEMS = API_BASE_URL + 'get-store-items';
export const FETCH_PRODUCT = 'https://2l2rojkmv4.execute-api.us-west-2.amazonaws.com/'+ENV;
export const FETCH_ROOM = 'https://nvckc8moz4.execute-api.us-west-2.amazonaws.com/'+ENV;
export const PRODUCT_MATERIAL_GET_BATCH = 'https://reksl0cik2.execute-api.us-west-2.amazonaws.com/' + ENV;
export const PRODUCT_LIST = API_BASE_URL + 'product-get-batch';
export const COMPANY_GET = 'https://ks8s8ia9pf.execute-api.us-west-2.amazonaws.com/' + ENV;
export const HIGH_POINT_CONTACT_IS = 'https://pdzpy5zvd4.execute-api.us-west-2.amazonaws.com/' + ENV;

//Template Actions API
export const TEMPLATE_ACTIONS = " https://jc4qy03fcc.execute-api.us-west-2.amazonaws.com/" + ENV;
export const TEMPLATE_BASE_URL = (ENV == 'staging') ? 'https://all3d-dev.s3.amazonaws.com/template_renders/' : 'https://d48f7equ64qjl.cloudfront.net/template_renders/';

//Customer Management APIs
export const CUSTOMER_GET_BATCH = API_BASE_URL + 'customer-get-batch';

//Lifestyles Feed API
export const GET_LIFESTYLES_FEED = API_BASE_URL + "get-lifestyles-feed";

//Add site visit API
export const ADD_SITE_VISIT = API_BASE_URL + "add-site-visit";

// Contact us form API
export const CONTACT_US = API_BASE_URL + "contact-us";

//Blogs API
export const BLOGS_CONTROLLER = API_BASE_URL + "blogs-controller";
export const getBaseURL = (platform) => {
  let base_url = "";
    if (platform == "aws") {
        base_url = "https://d48f7equ64qjl.cloudfront.net/";
      }
    else if (platform == "google") {
      base_url = "https://storage.googleapis.com/all3d/";
  }
  return base_url;
}
//AI Feed API
export const AI_ASSET_GENERATOR_HELPER = API_BASE_URL + "ai-asset-generator-helper";
export const POSTHOG_API_HOST = 'https://us.i.posthog.com'
export const POSTHOG_API_KEY = 'phc_R356fGfwrWI3RbnLQFFrbBPHe7W6WcHeKrAIT8vNKCp'